import { Reducer } from 'redux';

import { PublisherStartersLoadAction } from '../../domains/publisherStarters/actions.types';
import { setFulfilled, setPending, setRejected } from '../types';

import { PublisherStartersLifecycle } from './types';

const initialState: PublisherStartersLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<PublisherStartersLifecycle, PublisherStartersLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'PUBLISHER_STARTERS.LOAD_PENDING':
      return setPending();
    case 'PUBLISHER_STARTERS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'PUBLISHER_STARTERS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    default:
      return state;
  }
};

export default reducer;
